import { mediaRef } from '@/services/mediaAssets';

const coverImage = mediaRef('adventures/holiday-cut-dc-2022.png');
const heroImage = mediaRef('adventures/reckon-ball-2022-cut-no-text.png');

export default {
  slug: '2022',
  year: 2022,
  title: 'The First Reckon Ball',
  theme: 'The Beginning',
  coverImage,
  location: { city: 'Washington', state: 'D.C.', neighborhood: 'Georgetown' },
  hero: {
    eyebrow: 'Reckon Ball 2022',
    title: 'The Beginning',
    subtitle: 'Rosewood Washington, D.C. and CUT by Wolfgang Puck',
    summary: 'The first Reckon Ball established the tradition as an overnight celebration centered on exceptional hospitality, private dining, and time with the people who support the Reckon Crew.',
    image: heroImage,
    imageAlt: 'The Reckon Crew gathered around a holiday dinner table at CUT by Wolfgang Puck for Reckon Ball 2022',
  },
  hotel: {
    name: 'Rosewood Washington, D.C.',
    location: 'Georgetown, Washington, D.C.',
    overnightStay: true,
    summary: 'The Rosewood provided an intimate and refined setting for the first Reckon Ball. Staying at the hotel allowed the evening to feel like a true getaway rather than a single dinner reservation.',
  },
  timeline: [
    { title: 'Check-In', location: 'Rosewood Washington, D.C.' },
    { title: 'Cocktail Hour', location: 'The bar at CUT by Wolfgang Puck', description: 'The team and their spouses or guests gathered at the bar before dinner.' },
    { title: 'Gift Exchange', location: 'Rosewood Washington, D.C.', description: 'The first exchange was small, but it planted the seed for a lasting Reckon Ball tradition.' },
    { title: 'Private Dinner', location: 'CUT by Wolfgang Puck' },
    { title: 'Overnight Stay', location: 'Rosewood Washington, D.C.' },
  ],
  experiences: [
    {
      id: 'cocktail-hour', eyebrow: 'Before Dinner', title: 'Cocktail Hour at the Bar', venue: 'CUT by Wolfgang Puck', summary: 'The evening began at the bar, where Giovani hosted the group and became memorable for his famously generous pours.',
    },
    {
      id: 'gift-exchange', eyebrow: 'A Tradition Begins', title: 'The First Gift Exchange', venue: 'Rosewood Washington, D.C.', summary: 'The first gift exchange was much smaller than the versions that followed, but it established a tradition that would grow with the Reckon Ball.',
    },
  ],
  traditions: [
    {
      type: 'gift-exchange', title: 'Gift Exchange', firstYear: 2022, summary: 'A small first exchange that grew in the years that followed.',
    },
    { type: 'cocktail-hour', title: 'Cocktail Hour', firstYear: 2022 },
    { type: 'overnight-stay', title: 'Overnight Stay', firstYear: 2022 },
  ],
  dining: {
    restaurant: 'CUT by Wolfgang Puck',
    date: '2022-12-10',
    hotelOrProperty: 'Rosewood Washington, D.C.',
    location: 'Georgetown, Washington, D.C.',
    privateDining: true,
    exclusiveSpace: 'Private dining room',
    summary: 'A private dinner at CUT became the centerpiece of the first Reckon Ball and set the standard for the annual dining tradition.',
    menu: {
      eventTitle: 'The First Reckon Ball',
      year: 2022,
      restaurant: 'CUT by Wolfgang Puck',
      location: 'Georgetown, Washington, D.C.',
      sections: [
        {
          title: 'Cocktail Reception',
          serviceStyle: 'passed',
          items: [
            { name: 'Prawn Cocktail', description: 'Horseradish, cocktail sauce and lemon' },
            { name: 'Maine Lobster Rolls', description: 'Herb remoulade and celery hearts' },
            { name: 'American Wagyu Sliders', description: 'Brioche buns, aged Vermont cheddar and sweet pickles' },
          ],
        },
        { title: 'Dinner', serviceStyle: 'choice', items: [{ name: 'Porcini Mushroom Tortelloni' }, { name: 'Bone-In New York Steak' }, { name: 'Virginia Rockfish' }] },
        { title: 'Dessert', items: [{ name: 'Spanish Cheesecake' }] },
      ],
    },
  },
  signatureExperience: {
    eyebrow: 'A Memorable Welcome',
    title: "Giovani's Hospitality",
    summary: "Giovani's generous hospitality at the CUT bar became one of the defining memories of the first Reckon Ball.",
  },
  memories: [],
  gallery: [],
  relatedYears: [2023, 2024, 2025],
  tags: ['reckon-ball', 'gift-exchange', 'private-dining', 'overnight-stay', 'washington-dc'],
};
